var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SectionTitle',[_vm._v(" Get obligation free advice. Use the form below, or call (07) 4051 9300 ")]),_c('Form',{staticClass:"consultation-form",attrs:{"type":"Variations.FreemansProperty.ConsultationForm"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }